import { ProjectType } from '../enums/project.enum';

export function getBrandDefaultRoute(): string {
  return 'dashboard';
}

export function getBrandRedirectUrl(endpoint: string): string {
  const baseUrl = normalizeEndpoint(endpoint);
  const routePrefix = getMountedRoutePrefix(baseUrl, 'brand');

  return `${baseUrl}${routePrefix}${getBrandDefaultRoute()}`;
}

export function getFactoryDefaultRoute(userOrRole: any): string {
  const userRole = getUserRole(userOrRole);

  return userRole === 'user' ? 'footprint' : 'dashboard';
}

export function getFactoryRedirectUrl(endpoint: string, userOrRole: any): string {
  const factoryLandingRoute = getFactoryDefaultRoute(userOrRole);
  const baseUrl = normalizeEndpoint(endpoint);
  const routePrefix = getMountedRoutePrefix(baseUrl, 'factory');

  return `${baseUrl}${routePrefix}${factoryLandingRoute}`;
}

export function getConsultantDefaultRoute(user: any): string {
  const userRole = user?.userRole?.toLowerCase?.();

  if (userRole !== 'user') {
    return 'project';
  }

  const projectFactories = getConsultantProjectFactoryPermissions(user);
  const hasProjectPermission = projectFactories.some(
    (item: any) => item?.projectType === ProjectType.PROJECT
  );

  if (hasProjectPermission) {
    return 'project';
  }

  const hasAuditPermission = projectFactories.some(
    (item: any) => item?.projectType === ProjectType.ONLINE_AUDIT
  );

  if (hasAuditPermission) {
    return 'audit';
  }

  return 'settings';
}

export function getConsultantRedirectUrl(endpoint: string, user: any): string {
  const baseUrl = normalizeEndpoint(endpoint);
  const routePrefix = getMountedRoutePrefix(baseUrl, 'consultant');

  return `${baseUrl}${routePrefix}${getConsultantDefaultRoute(user)}`;
}

function getConsultantProjectFactoryPermissions(user: any): any[] {
  const projectFactories = user?.permissions?.scope?.PROJECT_FACTORIES;
  return Array.isArray(projectFactories) ? projectFactories : [];
}

function getUserRole(userOrRole: any): string | undefined {
  if (typeof userOrRole === 'string') {
    return userOrRole.toLowerCase?.();
  }

  const userRole =
    userOrRole?.userRole ??
    userOrRole?.data?.userRole ??
    userOrRole?.userInformation?.userRole ??
    userOrRole?.data?.userInformation?.userRole;

  return userRole?.toLowerCase?.();
}

function normalizeEndpoint(endpoint: string): string {
  return endpoint.endsWith('/') ? endpoint : `${endpoint}/`;
}

function getMountedRoutePrefix(baseUrl: string, mountPath: string): string {
  if (baseUrl.includes('localhost') || baseUrl.endsWith(`/${mountPath}/`)) {
    return '';
  }

  return `${mountPath}/`;
}
